/* eslint-disable react/display-name */
import React, { useState, useEffect } from "react"
import { useCookies } from "react-cookie"

const SessionContext = React.createContext()

// const ROOT_URL = '/.netlify/functions'
const DEFAUL_SESSION = {
  hasAccount: false,
  loggedIn: false,
  avatarUrl: null,
}

const SessionProvider = ({ children }) => {
  // fetch the cookies and initialize the session
  const [cookies] = useCookies(["box_active_user_subdomain", "logged_in"])
  const [session, setSession] = useState(DEFAUL_SESSION)

  // sets the session to a state where we know the user has an account
  // and uses a cookie to determine the user's logged in state
  const setHasAccount = () => setSession((s) => ({
    ...s,
    ...{
      hasAccount: true,
      loggedIn: cookies.logged_in === "true",
    },
  }))

  // check if the box_active_user_subdomain cookie is set and if so start
  // updating the session and fectching user details
  useEffect(() => {
    if (!cookies.box_active_user_subdomain) {
      return
    }
    setHasAccount()
  }, [])

  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  )
}

/* eslint-disable react/display-name */
const withSession = (WrappedComponent) => (props) => (
  <SessionContext.Consumer>
    {(session) => <WrappedComponent {...props} session={session} />}
  </SessionContext.Consumer>
)

export default SessionContext
export { SessionProvider, withSession }
